import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import OmOs from './pages/OmOs';
import Kontakt from './pages/Kontakt';
import BygGaranti from './pages/BygGaranti';
import Flisearbejde from './pages/Flisearbejde';
import Privatpolitik from './pages/Privatpolitik';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<OmOs />} />
            <Route path="/kontakt" element={<Kontakt />} />
            <Route path="/byg-garanti" element={<BygGaranti />} />
            <Route path="/galleri" element={<Flisearbejde />} />
            <Route path="/privatpolitik" element={<Privatpolitik />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
